/**
 * Created by Daniel on 09/04/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Subject } from 'rxjs';

export enum workFlowType {
    INIT = 'init',
    SCROLL = 'scroll',
    UPDATED = 'updated',
}
export enum CalendarScreenViewType {
    Day = 'Day',
    WorWeek = 'WorWeek',
    Week = 'Week',
    Month = 'Month'
}

export class CalendarScreenConfig {
    prefix: string;         // smart reducer action prefix name
    instanceId: string;     // smart reducer action prefix value
    viewType: CalendarScreenViewType;
    actions$: Subject<any>;
    events$: Subject<any>;

    constructor(prefix: string, instanceId: string) {
        this.prefix = prefix;
        this.instanceId = instanceId;
        this.viewType = CalendarScreenViewType.Month;
        this.actions$ = new Subject<any>();
        this.events$ = new Subject<any>();
    }
}


